import { render, staticRenderFns } from "./learning.vue?vue&type=template&id=04aab72c&scoped=true"
import script from "./learning.vue?vue&type=script&lang=js"
export * from "./learning.vue?vue&type=script&lang=js"
import style0 from "./learning.vue?vue&type=style&index=0&id=04aab72c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04aab72c",
  null
  
)

export default component.exports